import React from 'react'
import { Image, Segment, Header } from 'semantic-ui-react'

const ActionsMetric = (props) => (
    <Segment>
        <Header as='h2'>
            2. HOW ACTIVE WERE YOU THIS WEEK?
        </Header>
        <p>
            The chart below shows the three key actions you can take in the program to improve your mental wellbeing.
            Each action is compared to your best performance for that action (Best of Program), i.e., the week in which you had the highest score.
        </p>
        <ul>
            <li>The first action is the total number of emotions you logged in the past seven days.</li>
            <li>The second action is the total number of exercises you completed.</li>
            <li>The third action is the number of days you wore your Feel Emotion Sensor.</li>
        </ul>
        <p>
            You collect one point for every day of the week that you have worn it at least for one hour. For a breakdown of your “Wearing Time”, 
            please check the previous chart.
        </p>
        <p>
            Tip: Can you think of any reasons why your actions this week were lower/higher than your 'Best of Program' scores? Don't forget to discuss this with your
            Feel Provider.
        </p>
        <Header as='h3'>
            Your Mental Health Actions
        </Header>
        <Image src={`data:image/jpeg;base64,${props.actions_metric}`} alt={`${"actions.png"}`} centered/>
    </Segment>
)

export default ActionsMetric



// WEBPACK FOOTER //
// ./src/components/participant-feel-data-reports/metrics/actions.js